import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FaCaretDown } from "react-icons/fa";
import { MdExitToApp } from "react-icons/md";
import Bell from "./Bell";
import "./header.scss";

class Header extends Component {
  constructor() {
    super();
    this.state = {
      showMenu: false,
    };
    this.handleDDClick = this.handleDDClick.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentWillMount() {
    document.addEventListener("mousedown", this.handleClickOutside, false);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, false);
  }

  handleDDClick = () => {
    this.setState({ showMenu: !this.state.showMenu });
  };

  handleClickOutside(e) {
    if (document.getElementById("main-content").contains(e.target)) {
      this.setState({ showMenu: false });
    }
  }

  handleRedirect(route) {
    this.setState({ showMenu: false });
    if (route == "/auth/auth/logout") {
      window.location.href =
        window.location.protocol +
        "//" +
        window.location.host +
        "/auth/auth/logout?action=nav-logout-clicked";
    } else {
      this.props.history.push(route);
    }
  }
  render() {
    return (
      <div>
        <header className="usa-header site-header" role="banner">
          <div className="usa-navbar site-header-navbar">
            <div className="usa-logo site-logo" id="logo">
              <em className="usa-logo-text">
                <a
                  href="/dashboard"
                  title="Home"
                  aria-label="Foreign Labor Application Gateway home"
                >
                  FOREIGN LABOR APPLICATION GATEWAY
                </a>
                <span className="vertical-line-right line-spacer-break">|</span>
              </em>
              <span>
                <div
                  className="usa-header-text usa-menu-dropdown"
                  onClick={(e) => {
                    this.handleDDClick(e);
                  }}
                >
                  <span>
                    <a>{this.props.user ? this.props.user : "loading ..."} </a>
                    <span className="downCaretContainer">
                      <FaCaretDown className="downCaret" />
                    </span>
                  </span>
                </div>
                {this.state.showMenu ? (
                  <div className="usa-menu-dropdown-content">
                    <div className="arrow-style"></div>
                    <div className="Memenunu">
                      <div className="menu-item dropdown-label-View">
                        <span
                          style={{ color: "#0071BB", cursor: "pointer" }}
                          onClick={() => {
                            this.handleRedirect("/dashboard/myaccount");
                          }}
                        >
                          My Account
                        </span>
                      </div>
                    </div>
                    <hr />
                    <div className="menu">
                      <div className="menu-item dropdown-label-View dropdown-icon-container">
                        <span
                          style={{ color: "#9C1712", cursor: "pointer" }}
                          onClick={() => {
                            this.handleRedirect("/auth/auth/logout");
                          }}
                        >
                          Sign Out
                        </span>
                        <MdExitToApp size={25} className="sign-out-icon" />
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </span>
              <em className="usa-header-text no-right-border">
                <span className="vertical-line-left">|</span>
                <a
                  className="help-dashboard-link"
                  href="https://flag.dol.gov/support/FAQ"
                  target="_blank"
                >
                  HELP
                </a>
                <span className="vertical-line-right">|</span>
              </em>
              <Bell />
            </div>
          </div>
        </header>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const user = props.user
    ? props.user
    : state.appReducer.userDataReducer.data.email;
  return {
    user: user,
  };
};

export default withRouter(connect(mapStateToProps, null)(Header));
